/**
 * Custom University of Cambridge material UI theme
 */

// Since the ordering of properties has some meaning to users editing this file even if they are of
// no interest to the code, we disable the alphabetical sort check.
//
// tslint:disable:object-literal-sort-keys

import { createTheme } from '@mui/material/styles';

export const drawerWidth = 30 * 8;

const theme = createTheme({
  palette: {
    primary: {
      light: '#5fa7ff',
      main: '#0b79d0',
      dark: '#004e9e',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ffbc45',
      main: '#ff8b00',
      dark: '#c55c00',
      contrastText: '#fff',
    },
    text: {
      primary: '#fff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      // adjusted this breakpoint to improve the grants table layout
      md: 1100,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
